<template>
  <div class="map">
    <Header :title="$route.meta.title"></Header>
    <div id="container"></div>
    <p>签到地点：成都市高新区天府大道1700号</p>
    <p>签到时间：{{time}}</p>
    <van-button type="primary" color="#7469F8" block @click="sign()">确定签到</van-button>
  </div>
</template>
<script>
export default {
  data(){
    return{
      time:'',
      markers: [                 
        {
          "id":1,
          "name":"成都市高新区天府大道1700号",
          "latitude":"30.57755682740678",
          "longitude":"104.06820463292867"
        },
        // {
        //   "id":2,
        //   "name":"北京七天酒店",
        //   "latitude":"39.9254100000",
        //   "longitude":"116.5220000000"
        // }
      ]
    }
  },
  mounted(){
    this.initMap(this.markers)
    this.getTime()
  },
  methods:{
    getTime(){
      let date = new Date()
      // this.time = date.getFullYear() + '-' + 
      //             (date.getMonth() + 1) + '-' + 
      //             date.getDate() + ' ' + 
      //             date.getHours() + ':' + 
      //             date.getMinutes() + ':' + 
      //             date.getSeconds()
      this.time = date.toLocaleString()
    },
    sign(){
      this.getTime()
      this.$toast.success('签到成功!')
    },
    initMap (arr) {
      // 默认以数组第一项为中心
      var center = new qq.maps.LatLng(arr[0].latitude, arr[0].longitude);
      var map = new qq.maps.Map(
        document.getElementById("container"),
        {
          center: center,
          zoom: 16,
          viewMode:'2D'
        }
      );
      // 提示窗
      var info = new qq.maps.InfoWindow({
        map: map
      });
      for (var i = 0; i < arr.length; i++) {
        var data = arr[i];
        // 创建标记
        var marker = new qq.maps.Marker({ 
            position: new qq.maps.LatLng(data.latitude, data.longitude), 
            map: map 
        });
        // 将必要的数据存入每一个对应的marker对象
        marker.id = data.id;
        marker.name = data.name;
        // 为标记添加事件，这里可改为点击事件
        qq.maps.event.addListener(marker, 'mouseover', function() {
            info.open();
            // 设置提示窗内容（this指向marker对象）
            info.setContent(`<div><p>${this.name}</p></div>`);
            // 提示窗位置 
            info.setPosition(new qq.maps.LatLng(this.position.lat, this.position.lng));
        });
        qq.maps.event.addListener(marker, 'mouseout', function() {
            info.close();                    
        });
      }
    },
    selectLoaction(address) {
　　//调用地址解析类
      let geocoder = new qq.maps.Geocoder({
      　　complete: function (result) {
          　　location.href = "http://apis.map.qq.com/uri/v1/marker?marker=coord:" + result.detail.location.lat + "," + result.detail.location.lng + ";title:想要显示的坐标名称&referer=myapp";
          }
      });
      geocoder.getLocation(address);
      console.log(geocoder.getLocation(address));
    }
  }
}
</script>
<style scoped lang="less">
.map{
  padding: 0 1.25rem;
  #container{
    width: 100%;
    height: 60vh;
  }
  >p{
    color: @attendance-color-2;
    font-size: 0.875rem;
    margin-top: 0.625rem;
  }
  >button{
    margin-top: 1.875rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/location/index.vue